import React, { useState } from "react";
import { Icon } from "@iconify/react";
import "./reusable.css";
import Modal from "react-modal";
import ReviewCourseInfoModal from "../../modals-pages/dashboard-modals/ReviewCourseInfoModal";
import { useNavigate } from "react-router-dom";
import { encryptURI } from "../../../utils/encryption";
import { toast } from "react-toastify";

const MyCourseCard = ({ course }) => {
  const navigate = useNavigate();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState("");

  const openModal = (modalType) => {
    setIsOpen(true);
    setModalType(modalType);
  };

  function closeModal() {
    setIsOpen(false);
  }

  const likesPercent = (likes, courseEnrollment) => {
    if (likes === 0) return 0.0;
    return ((likes / courseEnrollment) * 100).toFixed(1);
  };


  const handleFeedbackNavigation = (course) => {
    const courseTitle = course?.course?.title || "";

    if (courseTitle === "Self Awareness") {
      navigate(`/dashboard/feedback/self-awareness`, {
        state: { enrollmentData: course },
      });
    } else if (courseTitle === "Resilience & Grit") {
      navigate(`/dashboard/resilience_grit/feedback`, {
        state: { enrollmentData: course },
      });
    } else if (courseTitle === "Emotional Regulation") {
      navigate(`/dashboard/emotional_regulation/feedback`, { state: { enrollmentData: course } })
    } else if (courseTitle === "Transition 2") {
      navigate(`/dashboard/transition_2/feedback`, { state: { enrollmentData: course } })
      
    } else if (courseTitle === "TOT Course 1" || courseTitle.includes("Feel It. Teach It. Transform Lives")) {
      navigate(`/dashboard/tot/feedback`, {
        state: { enrollmentData: course },
      });
    } else if (courseTitle === "TOT Course 2" || courseTitle.includes("Leaving No Learner Behind")) {
      navigate(`/dashboard/tot_2/feedback`, {
        state: { enrollmentData: course },
      });
    }else {
      navigate(`/dashboard/${courseTitle}/feedback`, {
        state: { enrollmentData: course },
      });
    }
  };

  const handleButtonClick = () => {
    const courseTitle = course?.course?.title || "";

    if (course?.progress === 100) {
      openModal("feedback");
    } else if (course?.schoolCourseEnrollment?.status === "Deactivated") {
      return toast.info(
        "Course Deavtivated! Please contact admin for support."
      );
    }

    if (courseTitle === "Self Awareness") {
      navigate(`/dashboard/self-awareness-course`, {
        state: { enrollmentData: course },
      });
      localStorage.setItem(`${course._id}-can-see`, true);
    } else if (courseTitle === "Resilience & Grit") {
      navigate(`/dashboard/resilience_grit`, {
        state: { enrollmentData: course },
      });
    } else if (courseTitle === "Emotional Regulation") {
      navigate(`/dashboard/emotional_regulation`, { state: { enrollmentData: course } })
    }  else if (courseTitle === "Transition 2") {
      navigate(`/dashboard/transition_2`, { state: { enrollmentData: course } })

    }else if (courseTitle === "TOT Course 1" || courseTitle.includes("Feel It. Teach It. Transform Lives")) {
      navigate(`/dashboard/tot`, {
        state: { enrollmentData: course },
      });
    } else if (courseTitle === "TOT Course 2" || courseTitle.includes("Leaving No Learner Behind")) {
      navigate(`/dashboard/tot_2`, {
        state: { enrollmentData: course },
      });
    }else {
      navigate(`/dashboard/${courseTitle}`, {
        state: { enrollmentData: course },
      });
    }
  };

  return (
    <div style={{ backgroundColor: "#fff" }} className="reusable-course-card">
      <div className="course-card" style={{ height: "100%", width: "100%" }}>
        <div className="course-details">
          <div style={{ height: "250px", display: "block", width: "100%" }}>
            <img
              style={{
                display: "block",
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              src={course?.course.image}
              alt=""
              className={
                course?.course.description?.toLowerCase() === "growth mindset"
                  ? "growth-mindset"
                  : ""
              }
            />
          </div>

          <div className="px-3 py-2">
            <h3 style={{ color: "#329BD6", fontSize: "24px" }}>
              {course?.course?.topic}
            </h3>
            <h3 style={{ color: "#555", fontSize: "24px" }}>
              {course?.course.title}
            </h3>
            <p style={{ height: "70px" }}>
              {course?.course.description}
            </p>
            <div className="d-flex icons">
              {/* <span>
                <Icon icon="solar:user-linear" />
                {course?.course.courseEnrollment?.length}
              </span> */}
              <span>
                <Icon icon="mingcute:thumb-up-line" />{" "}
                {likesPercent(
                  course?.course.likes?.length,
                  course?.course.courseEnrollment?.length
                )}{" "}
                %
              </span>
              <span>
                <Icon icon="bi:book" />
                {course?.progress} %
              </span>
            </div>
          </div>
        </div>
        <div className="course-card-btn d-flex">
          {/* Review/Feedback Button */}
          {course.progress >= 100 ? (
            <button
              style={{
                backgroundColor: "#fff",
                color: "#329BD6",
                display: "flex",
                justifyContent: "center",
                gap: ".4rem",
                padding: ".5rem 8px",
                border: "1px solid #329bd6",
              }}
              className="btn card-btn feedback"
              onClick={() => handleFeedbackNavigation(course)}
            >
              <Icon icon="hugeicons:comment-01" /> Feedback
            </button>
          ) : (
            <button
              style={{
                backgroundColor: "#fff",
                border: "1px solid #329BD6",
                color: "#329BD6",
                display: "flex",
                justifyContent: "center",
                gap: ".4rem",
                width: "120px",
                padding: ".5rem 8px",
              }}
              className="btn card-btn preview"
              onClick={() => openModal("review")}
            >
              <Icon icon="prime:eye" /> Review
            </button>
          )}

          {/* Start/Resume/Completed Button */}
          <button
            style={{
              backgroundColor: course?.progress === 100 ? "#fff" : "#329BD6",
              color: course.progress === 100 ? "#50AA50" : "#fff",
              display: "flex",
              justifyContent: "center",
              gap: ".4rem",
              width: "120px",
              padding: ".5rem 8px",
            }}
            className="btn card-btn start-resume"
            onClick={handleButtonClick}
          >
            {course?.progress === 100 ? (
              <Icon width={25} icon="ph:seal-check-thin" />
            ) : (
              <Icon icon="pepicons-print:play-circle" />
            )}
            {course?.progress === 100
              ? "Completed"
              : course.progress === 0
                ? "Start"
                : "Resume"}
          </button>
          {course?.progress > 0 && course?.progress < 100 && (
            <Icon
              onClick={() => handleFeedbackNavigation(course)}
              style={{ color: "#329BD6" }}
              width={40}
              icon="hugeicons:comment-01"
            />
          )}
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="custom-modal"
        overlayClassName="custom-overlay"
        contentLabel="Example Modal"
        shouldCloseOnOverlayClick={true}
      >
        {modalType === "review" && (
          <ReviewCourseInfoModal course={course?.course} onClose={closeModal} />
        )}
        {modalType === "feedback" && (
          <div>
            <h2>Course Feedback</h2>
            {/* Insert feedback form or content */}
            <button onClick={closeModal}>Close</button>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default MyCourseCard;
